export default __webpack_public_path__ + "static/media/cover_letter.aec0dc94.png";